// frontend/src/config/categories.js
//
// Categories themselves come from the API (GET /api/tools/categories, backed by
// backend/src/config/categories.js). This file only holds the bits the browser
// needs when a category is missing or hasn't loaded yet.

export const COLOR_SLOTS = ['indigo', 'amber', 'teal', 'violet', 'rose', 'emerald'];

// Tools created before categories existed have no `category`, as do tools whose
// category was removed from the backend config. They stay reachable under their
// own heading rather than vanishing from the catalog.
export const UNCATEGORISED_KEY = '__uncategorised';

export const UNCATEGORISED = {
  key: UNCATEGORISED_KEY,
  label: 'Uncategorised',
  blurb: 'These tools need a category picking in Admin → Tools.',
  color: 'rose',
};

export const findCategory = (categories, key) =>
  categories.find((c) => c.key === key) || UNCATEGORISED;

export const isUncategorised = (categories, tool) => {
  // While the taxonomy is still loading, nothing is uncategorised — otherwise
  // the whole catalog flashes "Uncategorised" on first paint.
  if (categories.length === 0) return false;
  return !tool.category || !categories.some((c) => c.key === tool.category);
};
